import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47c7284e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container auth-container" }
const _hoisted_2 = { class: "container-form py-56 px-32 px-sm-56" }
const _hoisted_3 = { class: "h4 title mb-36 mb-sm-56 text-primary" }
const _hoisted_4 = { class: "user-info mb-40" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-user me-12",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('¡Felicidades!')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(// eslint-disable-next-line max-len
          _ctx.$t('Tu contraseña ha sido restablecida de forma satisfactoria. Ya puedes volver a iniciar sesión e introducir tus nuevos credenciales.')), 1),
      _createVNode(_component_router_link, {
        class: "btn btn-icon btn-sm btn-secondary",
        "aria-label": _ctx.$t('Iniciar sesión'),
        to: {name: 'login'}
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('Iniciar sesión')), 1)
        ]),
        _: 1
      }, 8, ["aria-label"])
    ])
  ]))
}